import React from 'react';
import { useSelector } from 'react-redux';
import { Row } from 'antd';
import PropTypes from 'prop-types';

import ABWorkReportingBucketMapping from './ABWorkReportingBucketMapping';
import ABWorkReportingBatchEmailSettings from './ABWorkReportingBatchEmailSettings';
import ABWorkReportingJobCodeSettings from './ABWorkReportingJobCodeSettings';
import ABWorkReportingDisplayFields from './ABWorkReportingDisplayFields';
import ABWorkReportingImportMappings from './ABWorkReportingImportMappings';
import Permissions from '../../auth/Permissions';

export default function ABWorkReporting({
  settings,
  saveCompanySettings,
  saveDisplayFields,
  userDisplayFields,
  importMapping,
  onSaveImportMapping,
}) {
  const canEditSettings = Permissions.has('EDIT_AB_WORK_REPORTING_SETTINGS');
  const {
    abWorkReportingMapping = {},
    abWorkReportingBatchEmail = {},
  } = settings;

  const {
    itemId,
    segmentId,
    bidItemId,
    authorizedQuantityField,
    contractField,
    dateField,
    uomField,
    jobCodeField,
    inspectorField,
  } = abWorkReportingMapping;

  const bucketTemplates = useSelector((state) => state.buckets.bucketTemplates);
  const bucketTemplateMap = {};
  const bucketOptions = [];
  bucketTemplates.forEach((template) => {
    const bucketOption = {
      ...template,
      label: template.name,
      value: template.id,
    };
    bucketTemplateMap[template.id] = bucketOption;
    bucketOptions.push(bucketOption);
  });

  return (
    <Row justify="start" style={{ height: 'calc(100vh - 130px)', overflowY: 'auto', paddingBottom: 100 }}>
      <ABWorkReportingBucketMapping
        itemId={itemId}
        segmentId={segmentId}
        bidItemId={bidItemId}
        authorizedQuantityField={authorizedQuantityField}
        contractField={contractField}
        dateField={dateField}
        uomField={uomField}
        jobCodeField={jobCodeField}
        inspectorField={inspectorField}
        bucketOptions={bucketOptions}
        bucketTemplateMap={bucketTemplateMap}
        saveCompanySettings={saveCompanySettings}
        abWorkReportingMapping={abWorkReportingMapping}
        disabled={!canEditSettings}
      />
      <ABWorkReportingDisplayFields
        bucketTemplateMap={bucketTemplateMap}
        abWorkReportingMapping={abWorkReportingMapping}
        saveDisplayFields={saveDisplayFields}
        userDisplayFields={userDisplayFields}
      />
      <ABWorkReportingDisplayFields
        bucketTemplateMap={bucketTemplateMap}
        abWorkReportingMapping={abWorkReportingMapping}
        saveDisplayFields={saveDisplayFields}
        userDisplayFields={userDisplayFields}
        isWorkReportEntryMapping
      />
      <ABWorkReportingImportMappings
        mapping={importMapping}
        onSaveMapping={onSaveImportMapping}
        disabled={!canEditSettings}
      />
      <ABWorkReportingBatchEmailSettings
        batchEmail={abWorkReportingBatchEmail}
        saveCompanySettings={saveCompanySettings}
        disabled={!canEditSettings}
      />
      <ABWorkReportingJobCodeSettings
        disabled={!canEditSettings}
      />
    </Row>
  );
}

ABWorkReporting.propTypes = {
  settings: PropTypes.shape({
    abWorkReportingBatchEmail: PropTypes.shape({
      subject: PropTypes.string,
      body: PropTypes.string,
      recipients: PropTypes.arrayOf(PropTypes.string),
    }),
    abWorkReportingMapping: PropTypes.shape({
      itemId: PropTypes.string,
      segmentId: PropTypes.string,
      bidItemId: PropTypes.string,
      authorizedQuantityField: PropTypes.string,
      contractField: PropTypes.string,
      dateField: PropTypes.string,
      uomField: PropTypes.string,
      jobCodeField: PropTypes.string,
      inspectorField: PropTypes.string,
    }),
  }).isRequired,
  saveCompanySettings: PropTypes.func.isRequired,
  saveDisplayFields: PropTypes.func.isRequired,
  userDisplayFields: PropTypes.object,
  importMapping: PropTypes.object,
  onSaveImportMapping: PropTypes.func.isRequired,
};
